import { StatusType } from 'enums/status-type.enum';
import React from 'react';
import Swal from 'sweetalert2';

import { IconButton } from '@material-ui/core';
import { Subject } from '@material-ui/icons';
import useStyles from 'components/FormContents/components/ActionButtons/styles';
import { useMutation } from '@apollo/client';
import { EXPAND_CONTENT_BY_TITLE } from 'queries/titleContent';
import { Toast } from 'components/Toast';

interface IContentExpansion {
  titleId: string;
  content: string;
  status: number;
}

export const ContentExpansion: React.FC<IContentExpansion> = ({
  titleId,
  content,
  status,
}) => {
  const classes = useStyles();

  const [expand] = useMutation(EXPAND_CONTENT_BY_TITLE, {
    onCompleted: () => {
      Toast('Sent successfully, please wait a moment.');
    },
    onError: (error) => {
      Toast(error.message, 'warning');
    },
  });

  const countWordsExcludingHTML = (content: string) => {
    const textOnly = content.replace(/<[^>]*>/g, ' ');
    const cleanedText = textOnly.replace(/\s+/g, ' ').trim();

    if (!cleanedText) return 0;
    return cleanedText.split(' ').length;
  };

  if (
    countWordsExcludingHTML(content) >= 1000 ||
    status !== StatusType.Published
  ) {
    return <></>;
  }

  const confirmAlert = async (subtitle: string) => {
    const result = await Swal.fire({
      title: 'Are you sure?',
      html: subtitle,
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#78001b',
      reverseButtons: true,
      confirmButtonText: 'Confirm',
      customClass: {
        container: classes.swalDialog,
      },
    });
    return result.value;
  };

  const handle = async () => {
    if (await confirmAlert('Can we expand the content with AI?')) {
      expand({
        variables: { titleId },
      });
    }
  };

  return (
    <IconButton
      onClick={handle}
      style={{
        padding: 2,
      }}
      color="primary"
    >
      <Subject />
    </IconButton>
  );
};
